import { DatePicker } from './date-picker.component';

export * from './date-picker.component';
export default DatePicker;

DatePicker.define('der-tailormade-appointment-booking-date-picker');

declare global {
    interface HTMLElementTagNameMap {
        'der-tailormade-appointment-booking-date-picker': DatePicker;
    }
}
